const sizes = {
  small: [],
  big: [
    "25x32+10", "22x32+12", "22x25+12", "24x32+11",
    "32x37+20", "32x37+18", "32x45+15", "35x45+15",
  ],
};

const raw = [
  [100, sizes.small, 47.3],
  [100, sizes.big, 49.5],
  [200, sizes.small, 27.5],
  [200, sizes.big, 29.7],
  [300, sizes.small, 24.2],
  [300, sizes.big, 19.8],
  [400, sizes.small, 17.6],
  [400, sizes.big, 19.8],
  [500, sizes.small, 15.4],
  [500, sizes.big, 17.6],
  [1000, sizes.small, 12.1],
  [1000, sizes.big, 13.2],
  [2000, sizes.small, 9.9],
  [2000, sizes.big, 11],
];

const data = raw
  .sort(([a], [b]) => b - a)
  .map(([prints, sizes, price]) => ({ prints, sizes, price }));

export function printPrice(size, prints) {
  return data.find(
    (row) => row.prints < prints && row.sizes.includes(size)
  )?.price;
}
